import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import FilterCloseIcon from "../../assets/filter-close.svg";
import FilterselectIcon from "../../assets/filter-blue.svg";
import { Dropdown, Button, Input } from "antd";
import { Checkbox } from "@vds/checkboxes";
import {
  ArrowUpOutlined,
  ArrowDownOutlined,
  SearchOutlined,
} from "@ant-design/icons";

function DropdownFilterWithSearchAndCheckboxWithoutSort(props) {
  const { text, checkboxItems = [], isSearchable, onReset, onApply } = props;
  const [filters, setFilters] = useState({
    isOpen: false,
    isAsc: true,
    isFilterBoxOpen: null,
    filters: {
      text: "",
      checkboxItems: [],
    },
  });

  useEffect(() => {
    if (
      checkboxItems?.length > 0
    ) {
      setFilters((prev) => ({
        ...prev,
        filters: {
          ...prev.filters,
          checkboxItems: checkboxItems.map((item) => ({
            ...item
          })),
        },
      }));
    }
  }, [checkboxItems]);

  const handleSort = (val) => {
    if (val === "asc") {
      const sortedItemsAsc = [...filters.filters.checkboxItems].sort((a, b) =>
        a.text.localeCompare(b.text)
      );
      setFilters((prev) => ({
        ...prev,
        isAsc: true,
        filters: {
          ...prev.filters,
          checkboxItems: sortedItemsAsc,
        },
        isFilterBoxOpen: true,
      }));
    } else {
      const sortedItemsDesc = [...filters.filters.checkboxItems].sort((a, b) =>
        b.text.localeCompare(a.text)
      );
      setFilters((prev) => ({
        ...prev,
        isAsc: false,
        filters: {
          ...prev.filters,
          checkboxItems: sortedItemsDesc,
        },
        isFilterBoxOpen: true,
      }));
    }
  };

  const handleReset = (e) => {
    e.preventDefault();
    const resetFilters = {
      text: "",
      checkboxItems: checkboxItems.map((item) => ({
        ...item,
        value: false,
      })),
    };

    setFilters({
      isOpen: false,
      isAsc: true,
      isFilterBoxOpen: false,
      filters: resetFilters,
    });

    onReset();
  };

  const handleApplyFilter = (e) => {
    e.preventDefault();
    setFilters((prev) => ({ ...prev, isFilterBoxOpen: false, isOpen: false }));

    const selectedCheckboxes = filters.filters.checkboxItems
      .filter((item) => item.value)
      .map((item) => item.text);

    onApply({
      filters: filters.filters,
      filteredResult: selectedCheckboxes,
      isAsc: filters.isAsc,
    });
  };

  const handleCheckboxChange = (val) => {
    setFilters((prev) => {
      const updatedItems = prev.filters.checkboxItems.map((item) =>
        item.text === val ? { ...item, value: !item.value } : item
      );

      return {
        ...prev,
        isFilterBoxOpen: true,
        filters: {
          ...prev.filters,
          checkboxItems: updatedItems,
        },
      };
    });
  };

  const handleTextChange = (val) => {
    setFilters((prev) => {
      return {
        ...prev,
        isFilterBoxOpen: true,
        filters: {
          ...prev.filters,
          text: val,
        },
      };
    });
  };

  const handleOpenChange = (val) => {
    if (val === false) {
      if (filters?.isOpen === true) {
        setFilters((prev) => ({ ...prev, isFilterBoxOpen: null, isOpen: val }));
      }
    } else {
      setFilters((prev) => ({ ...prev, isOpen: val }));
    }
  };

  function isAnyFilterTrue(data) {
    let isFilterTrue = false;

    if (data.text && data.text !== "") isFilterTrue = true;

    if (Object.values(data.checkboxItems).some((val) => val.value === true)) {
      isFilterTrue = true;
    }

    return isFilterTrue;
  }

  let items = [];

  const sortableMenus = [
    {
      label: (
        <div>
          <span className="font-face-vzw ats-filter-header">Filter</span>
        </div>
      ),
    },
    {
      label: (
        <div onClick={(e) => e.stopPropagation()}>
          <Input
            data-testid="dropdown-filter-search-input"
            style={{
              width: "90%",
              height: "32px",
              marginTop: "5px",
              marginBottom: "5px",
              marginLeft: "auto",
              marginRight: "auto",
              borderRadius: "50px", // Circular edges
              paddingLeft: "40px", // Extra space to accommodate the icon
              display: "flex", // Use flexbox for horizontal alignment
              alignItems: "center", // Vertically center items
            }}
            name="name"
            value={filters.filters.text}
            className="form-control input-styles"
            type="search"
            placeholder="Search"
            onChange={(e) => {
              e.stopPropagation();
              handleTextChange(e.target.value);
            }}
            onKeyDown={(e) => {
              // Only handle left and right arrows
              if (e.key === "ArrowLeft" || e.key === "ArrowRight") {
                e.stopPropagation();
              }
            }}
            onClick={(e) => e.stopPropagation()}
            prefix={
              <SearchOutlined style={{ position: "absolute", left: "10px" }} />
            }
          />
        </div>
      ),
    },
  ];

  let menus = [];
  if (
    Array.isArray(filters.filters.checkboxItems) &&
    filters.filters.checkboxItems.length <= 6
  ) {
    if (filters.filters.text && filters.filters.text !== "") {
      menus = filters.filters.checkboxItems
        .filter((checkboxItem) =>
          checkboxItem.text
            .toLowerCase()
            .includes(filters.filters.text.toLowerCase())
        )
        .map((checkboxItem, index) => ({
          label: checkboxItems && (
            <Checkbox
              className="filter-checkbox"
              selected={checkboxItem?.value}
              onChange={(e) => {
                handleCheckboxChange(checkboxItem.text);
              }}
            >
              {checkboxItem?.text}
            </Checkbox>
          ),
          key: `${index + 1}`,
        }));
    } else {
      menus = filters.filters.checkboxItems.map((checkboxItem, index) => ({
        label: checkboxItems && (
          <Checkbox
            className="filter-checkbox"
            selected={checkboxItem?.value}
            onChange={(e) => {
              handleCheckboxChange(checkboxItem.text);
            }}
          >
            {checkboxItem?.text}
          </Checkbox>
        ),
        key: `${index + 1}`,
      }));
    }
  } else if (
    Array.isArray(filters.filters.checkboxItems) &&
    filters.filters.checkboxItems.length > 6
  ) {
    let bigMenus = [];
    if (filters.filters.text && filters.filters.text !== "") {
      bigMenus = filters.filters.checkboxItems
        .filter((checkboxItem) =>
          checkboxItem.text
            .toLowerCase()
            .includes(filters.filters.text.toLowerCase())
        )
        .map((checkboxItem, index) => {
          return (
            <li key={index}>
              <Checkbox
                className="filter-checkbox"
                selected={checkboxItem?.value}
                onChange={(e) => {
                  handleCheckboxChange(checkboxItem.text);
                }}
              >
                {checkboxItem?.text}
              </Checkbox>
            </li>
          );
        });
    } else {
      bigMenus = filters.filters.checkboxItems.map((checkboxItem, index) => {
        return (
          <li key={`${index}-${checkboxItem?.value}`}>
            <Checkbox
              className="filter-checkbox"
              selected={checkboxItem?.value}
              onChange={(e) => {
                handleCheckboxChange(checkboxItem.text);
              }}
            >
              {checkboxItem?.text}
            </Checkbox>
          </li>
        );
      });
    }
    menus?.push({
      label: (
        <div className="ats-big-dropdown-filter">
          <ul>{bigMenus}</ul>
        </div>
      ),
      key: `bigMenus`,
    });
  }

  menus?.push({
    label: (
      <div className="ats-filter-footer">
        <button onClick={handleReset} className="reset-filter">
          Reset filter
        </button>
        <Button
          onClick={handleApplyFilter}
          className="ats-filter-footer-button"
          color="default"
          variant="solid"
        >
          Apply
        </Button>
      </div>
    ),
  });

  if (isSearchable) {
    items = [...sortableMenus, ...menus];
  } else {
    items = [
      {
        label: (
          <div>
            <span className="font-face-vzw ats-filter-header">Filter</span>
          </div>
        ),
      },
      ...menus,
    ];
  }

  return (
    <Dropdown
      menu={{
        items,
      }}
      trigger={["click"]}
      onOpenChange={handleOpenChange}
      open={filters.isOpen}
      overlayClassName="ats-filter-overlay"
    >
      <div className="ats-filter">
        <span className="font-face-vzw">{text}</span>
        <img
          src={
            filters.isOpen || isAnyFilterTrue(filters?.filters)
              ? FilterselectIcon
              : FilterCloseIcon
          }
          alt="filter-icon"
        />
      </div>
    </Dropdown>
  );
}

DropdownFilterWithSearchAndCheckboxWithoutSort.propTypes = {
  text: PropTypes.string.isRequired,
  isSearchable: PropTypes.bool,
  checkboxItems: PropTypes.arrayOf(
    PropTypes.shape({
      text: PropTypes.string.isRequired,
      value: PropTypes.bool,
    })
  ).isRequired,
  onReset: PropTypes.func.isRequired,
  onApply: PropTypes.func.isRequired,
};

export default DropdownFilterWithSearchAndCheckboxWithoutSort;